import { Cmd } from 'redux-loop';
import { Wallet, WalletsApi } from 'api';
import { makeAuthenticatedApi } from 'core/api';

export async function getWalletsEffect(getState: Cmd.GetState): Promise<Wallet[]> {
  const walletsApi: WalletsApi = makeAuthenticatedApi(WalletsApi, getState);

  return await walletsApi.walletsList();
}
